(() => {
  const positionProductEntry = root => {
    const entry = root.querySelector?.('[data-club-product-entry]');
    if (!entry || entry.dataset.clubPositioned) return;
    const productForm = root.querySelector?.('main form.product-form[action*="/cart/add"]');
    if (!productForm) return;
    entry.dataset.clubPositioned = 'true';
    productForm.insertAdjacentElement('afterend', entry);
  };

  const initHomePlans = root => {
    if (root.dataset.clubReady) return;
    root.dataset.clubReady = 'true';
    const buttons = [...root.querySelectorAll('[data-club-home-plan]')];
    const composition = root.querySelector('[data-club-home-composition]');
    const price = root.querySelector('[data-club-home-price]');
    const english = document.documentElement.lang.startsWith('en');
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(item => item.classList.toggle('is-active', item === button));
      composition.textContent = `${button.dataset.size} ${english ? 'soaps + lip balm + mini deodorant' : 'jabones + lip balm + mini desodorante'}`;
      price.textContent = button.dataset.price;
    }));
  };

  const initBuilder = root => {
    if (root.dataset.clubReady) return;
    root.dataset.clubReady = 'true';
    const english = root.dataset.language === 'en';
    const stages = [...root.querySelectorAll('[data-club-stage]')];
    const progress = [...root.querySelectorAll('[data-club-step-jump]')];
    const tiers = [...root.querySelectorAll('[data-club-tier]')];
    const soapCards = [...root.querySelectorAll('[data-club-soap]')];
    const singleCards = [...root.querySelectorAll('[data-club-single]')];
    const plans = [...root.querySelectorAll('[data-club-plan]')];
    const modes = [...root.querySelectorAll('[data-club-mode]')];
    let step = 0;
    let tier = tiers.find(item => item.classList.contains('is-selected')) || tiers[0];
    let size = Number(tier?.dataset.size || 6);
    let variantId = tier?.dataset.variantId || '';
    let price = tier?.dataset.price || '$48';
    let plan = plans.find(item => item.classList.contains('is-selected')) || plans[0];
    let mode = 'repeat';
    let lip = null;
    let mini = null;
    const soaps = new Map();

    const totalSoaps = () => [...soaps.values()].reduce((total, count) => total + count, 0);
    const getModeLabel = value => {
      if (value === 'half') return english ? 'Half favorites, half surprise' : 'Mitad favoritos, mitad sorpresa';
      if (value === 'surprise') return english ? 'Surprise me' : 'Sorpréndeme';
      return english ? 'Repeat my selection' : 'Repetir mi selección';
    };

    const showStep = next => {
      step = Math.max(0, Math.min(stages.length - 1, next));
      stages.forEach(stage => { stage.hidden = Number(stage.dataset.clubStage) !== step; });
      progress.forEach((button, index) => button.classList.toggle('is-active', Math.min(step, 3) === index));
      root.querySelector('.club-velvet-builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const syncSoaps = () => {
      const selected = totalSoaps();
      root.querySelector('[data-club-soap-count]').textContent = String(selected);
      root.querySelector('[data-club-soap-target]').textContent = String(size);
      soapCards.forEach(card => {
        const count = soaps.get(card.dataset.handle) || 0;
        card.classList.toggle('is-selected', count > 0);
        card.querySelector('[data-club-item-count]').textContent = String(count);
        const addLabel = card.querySelector('[data-club-plus-label]');
        if (addLabel) addLabel.textContent = count > 0
          ? (english ? '+ Add another' : '+ Añadir otro')
          : (english ? '+ Add' : '+ Añadir');
      });
      const next = stages[1]?.querySelector('[data-club-next]');
      if (next) next.disabled = selected !== size;
    };

    const syncSingles = () => {
      singleCards.forEach(card => {
        const selected = card.dataset.kind === 'lip'
          ? lip?.dataset.handle === card.dataset.handle
          : mini?.dataset.handle === card.dataset.handle;
        card.classList.toggle('is-selected', selected);
        const button = card.querySelector('[data-club-select-one]');
        if (button) button.textContent = selected
          ? (english ? '✓ Selected' : '✓ Elegido')
          : (english ? '+ Add' : '+ Añadir');
      });
      const next = stages[2]?.querySelector('[data-club-next]');
      if (next) next.disabled = !(lip && mini);
    };

    const trimSoaps = () => {
      let selected = totalSoaps();
      if (selected <= size) return;
      [...soaps.keys()].reverse().forEach(handle => {
        while (selected > size && (soaps.get(handle) || 0) > 0) {
          const next = soaps.get(handle) - 1;
          if (next) soaps.set(handle, next);
          else soaps.delete(handle);
          selected -= 1;
        }
      });
    };

    const updateTier = button => {
      tier = button;
      size = Number(button.dataset.size);
      variantId = button.dataset.variantId;
      price = button.dataset.price;
      tiers.forEach(item => item.classList.toggle('is-selected', item === button));
      trimSoaps();
      syncSoaps();
    };

    const fillRandom = () => {
      const available = [...soapCards];
      if (!available.length) return;
      while (totalSoaps() < size) {
        const card = available[Math.floor(Math.random() * available.length)];
        soaps.set(card.dataset.handle, (soaps.get(card.dataset.handle) || 0) + 1);
      }
      syncSoaps();
    };

    const soapSummary = () => soapCards
      .filter(card => (soaps.get(card.dataset.handle) || 0) > 0)
      .map(card => {
        const count = soaps.get(card.dataset.handle);
        return `${count}× ${card.dataset.title}`;
      });

    const renderSummary = () => {
      root.querySelector('[data-club-summary-size]').textContent =
        `${size} ${english ? 'soaps + lip balm + mini deodorant' : 'jabones + lip balm + mini desodorante'}`;
      root.querySelector('[data-club-summary-soaps]').textContent = soapSummary().join(' \u00B7 ');
      root.querySelector('[data-club-summary-lip]').textContent = lip?.dataset.title || '';
      root.querySelector('[data-club-summary-mini]').textContent = mini?.dataset.title || '';
      root.querySelector('[data-club-summary-plan]').textContent = plan?.dataset.planName || '';
      root.querySelector('[data-club-summary-mode]').textContent = getModeLabel(mode);
      root.querySelector('[data-club-summary-price]').textContent = price;
    };

    const cartProperties = () => {
      const properties = {
        'Club Velvet': `${size} ${english ? 'soaps + lip balm + mini deodorant' : 'jabones + lip balm + mini desodorante'}`,
        [english ? 'Lip balm' : 'Lip balm']: lip.dataset.title,
        [english ? 'Mini deodorant' : 'Mini desodorante']: mini.dataset.title,
        [english ? 'Future boxes' : 'Próximas cajas']: getModeLabel(mode),
        [english ? 'Member benefit' : 'Beneficio de miembro']: english ? '5% off every delivery' : '5% menos en cada entrega',
        [english ? 'Welcome gift' : 'Regalo de bienvenida']: english ? 'Soap Saver Bag \u00B7 first box only' : 'Soap Saver Bag \u00B7 solo primera caja',
        '_club_velvet': 'true'
      };
      let index = 1;
      soapCards.forEach(card => {
        const count = soaps.get(card.dataset.handle) || 0;
        for (let item = 0; item < count; item += 1) {
          properties[`${english ? 'Soap' : 'Jabón'} ${index}`] = card.dataset.title;
          index += 1;
        }
      });
      return properties;
    };

    const addClub = async checkout => {
      const status = root.querySelector('[data-club-status]');
      status.classList.remove('is-error');
      if (!variantId || !plan?.dataset.planId) {
        status.textContent = english
          ? 'Club Velvet is being connected to Shopify Subscriptions. Please try again shortly.'
          : 'Club Velvet se está conectando con Shopify Subscriptions. Intenta nuevamente en unos minutos.';
        status.classList.add('is-error');
        return;
      }
      const buttons = [...root.querySelectorAll('[data-club-add],[data-club-checkout]')];
      buttons.forEach(button => { button.disabled = true; });
      status.textContent = english ? 'Saving your Club Velvet…' : 'Guardando tu Club Velvet…';
      try {
        const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1,
              selling_plan: Number(plan.dataset.planId),
              properties: cartProperties()
            }]
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add Club Velvet.');
        status.textContent = english ? 'Club Velvet added.' : 'Club Velvet añadido.';
        location.href = checkout ? `${rootPath}checkout` : `${rootPath}cart`;
      } catch (error) {
        status.textContent = error.message;
        status.classList.add('is-error');
        buttons.forEach(button => { button.disabled = false; });
      }
    };

    tiers.forEach(button => button.addEventListener('click', () => updateTier(button)));
    soapCards.forEach(card => {
      card.querySelector('[data-club-soap-plus]')?.addEventListener('click', () => {
        if (totalSoaps() >= size) return;
        soaps.set(card.dataset.handle, (soaps.get(card.dataset.handle) || 0) + 1);
        syncSoaps();
      });
      card.querySelector('[data-club-soap-minus]')?.addEventListener('click', () => {
        const current = soaps.get(card.dataset.handle) || 0;
        if (current <= 1) soaps.delete(card.dataset.handle);
        else soaps.set(card.dataset.handle, current - 1);
        syncSoaps();
      });
    });
    singleCards.forEach(card => card.querySelector('[data-club-select-one]')?.addEventListener('click', () => {
      if (card.dataset.kind === 'lip') lip = card;
      else mini = card;
      syncSingles();
    }));
    plans.forEach(button => button.addEventListener('click', () => {
      plan = button;
      plans.forEach(item => item.classList.toggle('is-selected', item === button));
    }));
    modes.forEach(button => button.addEventListener('click', () => {
      mode = button.dataset.clubMode;
      modes.forEach(item => item.classList.toggle('is-selected', item === button));
    }));
    root.querySelector('[data-club-random-soaps]')?.addEventListener('click', fillRandom);
    root.querySelectorAll('[data-club-next]').forEach(button => button.addEventListener('click', () => showStep(step + 1)));
    root.querySelectorAll('[data-club-prev]').forEach(button => button.addEventListener('click', () => showStep(step - 1)));
    progress.forEach(button => button.addEventListener('click', () => {
      const target = Number(button.dataset.clubStepJump);
      if (target === 0 || (target === 1) || (target === 2 && totalSoaps() === size) || (target === 3 && totalSoaps() === size && lip && mini)) showStep(target);
    }));
    root.querySelector('[data-club-review]')?.addEventListener('click', () => {
      renderSummary();
      showStep(4);
    });
    root.querySelector('[data-club-add]')?.addEventListener('click', () => addClub(false));
    root.querySelector('[data-club-checkout]')?.addEventListener('click', () => addClub(true));

    const requested = new URLSearchParams(location.search).get('start');
    const requestedSoap = requested && soapCards.find(card => card.dataset.handle === requested);
    if (requestedSoap) soaps.set(requestedSoap.dataset.handle, 1);
    syncSoaps();
    syncSingles();
  };

  const init = root => {
    positionProductEntry(root);
    root.querySelectorAll('[data-club-home-plans]').forEach(initHomePlans);
    root.querySelectorAll('[data-club-velvet-builder]').forEach(initBuilder);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
